import upd from 'immutability-helper';
import * as Env from 'widget/env';

const useHandleDeletedMessage = (
  setMessageList: Env.SetState<Env.Message[]>,
) => {
  const handleDeletedMessage = (message: Env.Message | undefined) => {
    if (!message) return;

    setMessageList(prevMessages => {
      const index = prevMessages.findIndex(m => m.id == message.id);
      if (index < 0) return prevMessages;

      return upd(prevMessages, { $splice: [[index]] });
    });
  };

  return handleDeletedMessage;
};

export default useHandleDeletedMessage;
